import { observable, computed, action } from 'mobx';
import { fromPromise } from 'mobx-utils';
import getUsersByIds from 'helper/getUsersByIds';

class UserMediaStore {
  @observable.ref videoPublication = null;
  @observable.ref audioPublication = null;
  @observable.ref screenSharePublication = null;
  @observable.ref isVideoEnabled = false;
  @observable.ref isAudioEnabled = false;
  @observable.ref isScreenShareEnabled = false;
  @observable.ref isVideoFullScreen = false;
  @observable.ref isScreenShareFullScreen = false;
  @observable.ref userId = '';
  @observable.ref participant = null;

  constructor(store) {
    this.store = store;
  }

  @computed
  get user() {
    const { reportingLibrary } = this.store;

    if (!this.userId) {
      return fromPromise(Promise.resolve({}));
    }

    return fromPromise(getUsersByIds(reportingLibrary, [this.userId]).then(users => users[0]));
  }

  sync = ({ userId }) => {
    this.userId = userId;
  };

  initUserMedia(participant, twilioRoom) {
    if (!twilioRoom) {
      this.handleRoomDisconnect();
      return;
    }

    this.participant = participant;

    twilioRoom
      .off('disconnected', this.handleRoomDisconnect)
      .on('disconnected', this.handleRoomDisconnect);

    const tracks = Array.from(participant.tracks.values());
    this.videoPublication = tracks.find(p => p.trackName === 'video');
    this.screenSharePublication = tracks.find(p => p.trackName === 'screen');
    this.audioPublication = tracks.find(p => p.trackName === 'audio');
  }

  @action
  toggleVideoFullScreen = () => {
    this.isVideoFullScreen = !this.isVideoFullScreen;
  };

  @action
  toggleScreenShareFullScreen = () => {
    this.isScreenShareFullScreen = !this.isScreenShareFullScreen;
  };

  // Release resources
  handleRoomDisconnect = () => {
    this.videoPublication = null;
    this.audioPublication = null;
    this.screenSharePublication = null;

    this.isVideoEnabled = false;
    this.isAudioEnabled = false;
    this.isScreenShareEnabled = false;

    this.participant = null;
  };
}

export default UserMediaStore;
